// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* baseModalStyle.css의 \`.MuiDialog-container .MuiPaper-root\` 규칙보다 우선해야 하므로 동일 깊이로 작성 */
.MuiDialog-container .MuiPaper-root.product-complaint-modal {
  width: 100%;
  max-width: 400px;
  margin: 0;
  padding: 0;
  border-radius: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/css/productComplaintModalStyle.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB","sourcesContent":["/* baseModalStyle.css의 `.MuiDialog-container .MuiPaper-root` 규칙보다 우선해야 하므로 동일 깊이로 작성 */\n.MuiDialog-container .MuiPaper-root.product-complaint-modal {\n  width: 100%;\n  max-width: 400px;\n  margin: 0;\n  padding: 0;\n  border-radius: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
